import ZChart from './ZChart.vue'

export default ZChart
